<template>
    <div class="is-relative">
        <div style="position: absolute; left: calc(0.75em);top:calc(0.5em);z-index: 10;font-weight: bold;text-align: right;min-width: 10px;">{{innerCode | num}}</div>
        <b-input
            custom-class="input__custom"
            type="text"
            maxlength="8"
            validation-message="Только цифры"
            pattern="[0-9]{0,8}"
            @keypress.native="checkField"

            :value="innerValue"
            @input="onChange"

        />
    </div>
</template>

<script>
import numeral from 'numeral'

export default {
    props: {
        value: {
            type: String,
            required: true,
        },
        code: {
            type: String,
        },
    },
    computed: {
        innerCode() {
            return (this.code ? numeral(this.code) : this.value.toString().substring(0, 2)).format('00')
        },
        innerValue() {
            return this.value.toString().substring(2)
        }
    },
    methods: {
        onChange(val) {
            this.$emit('input', val ? this.innerCode+''+val : '')
        },
        checkField ($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },
    }
}
</script>